<div class="header">
  <h1>{{ statusMessage }}</h1>
  <mat-chip-list *ngIf="statusMessage">
    <mat-chip color="primary" selected class="count-chip">{{
      dataSourceArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>
<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter contacts</mat-label>
        <input
          matInput
          (keyup)="filterProjects($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      class="table"
      matSort
      fixedLayout="true"
    >
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let project">
          {{ project.customerName | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="jobaddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
        <td mat-cell *matCellDef="let project">
          {{ project.jobaddress | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="estimatorName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estimator</th>
        <td mat-cell *matCellDef="let project">
          {{ project.estimatorName | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="soldByName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sold By</th>
        <td mat-cell *matCellDef="let project">
          {{ project.soldByName | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="approvalDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Approval Date</th>
        <td mat-cell *matCellDef="let project">
          {{ project.approvalDate | date : "shortDate" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="contractDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract Date</th>
        <td mat-cell *matCellDef="let project">
          {{ project.contractDate | date : "shortDate" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="projectShortName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Type</th>
        <td mat-cell *matCellDef="let project">
          {{ project.projectShortName }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No matching results
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="goToAccountingInfo(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
